'use strict';

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.filter("taux", function ($tauxFormat) {
  return function tauxFilter(taux, fixedDecimals, signed) {
    return $tauxFormat(taux, fixedDecimals, signed);
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/core/types/taux/taux-filters.js
// module id = 2734
// module chunks = 13